import { faBuilding } from '@fortawesome/free-solid-svg-icons';
import { HOME_TYPES, formatMoney } from '../Properties/constants';
import { StatusChip } from '../Property/UnitDrawer';
import { I } from '../Todos/ui';

const HOME_LABEL = Object.fromEntries(HOME_TYPES.map((t) => [t.value, t.label]));
const areaOf = (u) => u.area || u.address?.city || '--';
const bb = (u) => (u.bedrooms ? `${u.bedrooms} / ${u.bathrooms || 0}` : u.unitType === 'room' ? 'Room' : '--');

// ponytail: groups are derived by area with door counts. Per-group NTE/repair limits aren't modeled
// yet, so that column is omitted until there's a real source.
function groupsByArea(units) {
  const by = new Map();
  units.forEach((u) => {
    const key = areaOf(u);
    by.set(key, (by.get(key) || 0) + 1);
  });
  return [...by.entries()].sort((a, b) => b[1] - a[1]);
}

export default function PortfolioTab({ units, phone, onOpenUnit }) {
  const groups = groupsByArea(units);
  const table = phone ? (
    <div className="m-col gap8">
      {units.map((u) => (
        <button key={u._id} type="button" className="m-crow" onClick={() => onOpenUnit(u)}>
          <div className="m-row between">
            <span className="b sm">{u.name}</span>
            <StatusChip unit={u} />
          </div>
          <div className="m-sub">{[areaOf(u), HOME_LABEL[u.unitType], bb(u), formatMoney(u.rent)].filter(Boolean).join(' · ')}</div>
          <div className="m-sub">Owner {u.ownerName || '--'}</div>
        </button>
      ))}
    </div>
  ) : (
    <div className="m-tw">
      <table className="m-tbl">
        <thead>
          <tr>
            {['Property or unit', 'Area', 'Type', 'Beds / baths', 'Rent', 'Status', 'Owner'].map((c) => (
              <th key={c}>{c}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {units.length ? (
            units.map((u) => (
              <tr key={u._id} className="click" tabIndex={0} onClick={() => onOpenUnit(u)} onKeyDown={(e) => e.key === 'Enter' && onOpenUnit(u)}>
                <td>
                  <span className="b">{u.name}</span>
                </td>
                <td>{areaOf(u)}</td>
                <td>{HOME_LABEL[u.unitType] || '--'}</td>
                <td>
                  <span className="num">{bb(u)}</span>
                </td>
                <td>
                  <span className="b num">{formatMoney(u.rent) || '--'}</span>
                </td>
                <td>
                  <StatusChip unit={u} />
                </td>
                <td>{u.ownerName || '--'}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={7} className="m-empty">
                No units yet.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );

  return (
    <div className="m-col gap16">
      <div className={['m-four', phone && 'ph'].filter(Boolean).join(' ')}>
        {groups.map(([area, doors]) => (
          <section key={area} className="m-card sm" aria-label={area}>
            <div className="m-ch">
              <span className="m-bub">
                <I icon={faBuilding} />
              </span>
              <div className="grow">
                <div className="m-ct">{area}</div>
              </div>
            </div>
            <div className="m-big num">{doors}</div>
            <div className="m-sub">{doors === 1 ? 'door' : 'doors'}</div>
          </section>
        ))}
      </div>
      <div className="m-sub">
        {units.length} units · vacant units can be listed under Vacancies
      </div>
      {table}
    </div>
  );
}
